import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { Country } from '~shared/models';
import { CountriesService } from '~shared/services/countries.service';
import { CountriesActionTypes, ReadCountriesFailure, ReadCountriesSuccess } from './countries.actions';

@Injectable()
export class CountriesEffects {
  @Effect()
  readCountries$ = this.actions$.pipe(
    ofType(CountriesActionTypes.READ_COUNTRIES),
    mergeMap(() =>
      this.countriesService.read().pipe(
        map((countries: Country[]) => new ReadCountriesSuccess(countries)),
        catchError((error) => of(new ReadCountriesFailure(error)))
      )
    )
  );

  constructor(private actions$: Actions, private countriesService: CountriesService) {}
}
